{
    "name": "fe-package-packer",
    "version": "1.1.7",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --configuration=development",
        "start:aot": "ng serve --configuration=development-aot",
        "build": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=production",
        "build:preview": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=preview",
        "build:integration": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=integration",
        "build:staging": "rimraf dist && node --max_old_space_size=8196 node_modules/@angular/cli/bin/ng build --configuration=staging",
        "build:prod": "npm run build",
        "test": "npm run lint && npm run prettier",
        "lint": "eslint .",
        "docs": "npx compodoc -p tsconfig.json -n \"Quote Assist - documentation\"",
        "docs:start": "compodoc --serve --port 9000",
        "serve": "node node_modules/http-server/bin/http-server -c-1 -p 4200 dist",
        "serve:dev": "ng build --configuration=integration && npm run serve",
        "prettier": "prettier --check src/**/*.ts"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^17.3.6",
        "@angular/cdk": "^17.3.6",
        "@angular/common": "^17.3.6",
        "@angular/compiler": "^17.3.6",
        "@angular/core": "^17.3.6",
        "@angular/flex-layout": "^15.0.0-beta.42",
        "@angular/forms": "^17.3.6",
        "@angular/material": "^17.3.6",
        "@angular/material-moment-adapter": "^17.3.6",
        "@angular/platform-browser": "^17.3.6",
        "@angular/platform-browser-dynamic": "^17.3.6",
        "@angular/pwa": "0.12.2",
        "@angular/router": "^17.3.6",
        "@angular/service-worker": "^17.3.6",
        "@auth0/angular-jwt": "^4.2.0",
        "@microsoft/applicationinsights-web": "^2.7.4",
        "@ngx-translate/core": "^14.0.0",
        "@ngx-translate/http-loader": "^4.0.0",
        "@types/ineum": "^216.0.0",
        "@types/uuid": "^8.3.0",
        "@vi-succ/design-system-web": "^1.3.0",
        "@vi/global-header": "15.3.3",
        "@vi/quest": "15.1.5",
        "angular2-recaptcha": "^1.1.0",
        "core-js": "^2.5.4",
        "deepmerge-ts": "^7.0.3",
        "lodash": "^4.17.21",
        "moment": "^2.29.1",
        "ng-recaptcha": "^12.0.2",
        "ngx-translate-multi-http-loader": "17.0.0",
        "ngx-uploader": "^17.0.1",
        "rxjs": "^7.8.1",
        "tslib": "^2.0.0",
        "underscore": "^1.9.0",
        "uuid": "^8.3.2",
        "zone.js": "~0.14.4"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^17.3.6",
        "@angular-devkit/core": "^17.3.6",
        "@angular-eslint/builder": "17.3.0",
        "@angular-eslint/eslint-plugin": "17.3.0",
        "@angular-eslint/eslint-plugin-template": "17.3.0",
        "@angular-eslint/schematics": "17.3.0",
        "@angular-eslint/template-parser": "17.3.0",
        "@angular/cli": "^17.3.6",
        "@angular/compiler-cli": "17.3.6",
        "@angular/language-service": "^17.3.6",
        "@compodoc/compodoc": "^1.1.9",
        "@everest/codestyle": "^2.0.0",
        "@types/lodash": "^4.17.6",
        "@types/node": "~18.19.31",
        "@types/puppeteer": "^3.0.1",
        "@typescript-eslint/eslint-plugin": "7.2.0",
        "@typescript-eslint/parser": "7.2.0",
        "codelyzer": "^6.0.0",
        "eslint": "^8.57.0",
        "fs-finder": "^1.8.1",
        "http-server": "^0.11.1",
        "istanbul-reports": "^2.0.0",
        "jasmine-core": "~3.6.0",
        "jasmine-spec-reporter": "~5.0.0",
        "node-sass": "^9.0.0",
        "prettier": "^2.0.5",
        "puppeteer": "^4.0.1",
        "rimraf": "^2.6.2",
        "run-sequence": "2.2.1",
        "ts-node": "~7.0.0",
        "tslint": "~6.1.0",
        "tslint-config-prettier": "^1.18.0",
        "typescript": "5.4.5"
    }
}
